import { merge as _merge } from 'lodash'
import Swal, { SweetAlertResult } from 'sweetalert2'

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface IModalOptions {
    title: string
    text: string
    icon?: string
    showLoadingIndicator?: boolean
    overrideSwalProps?: any
}

export const showModal = (modalOptions: IModalOptions): Promise<SweetAlertResult> => {
    const swalOptions = {}

    Object.assign(swalOptions, { title: modalOptions.title, html: modalOptions.text, icon: modalOptions.icon })

    if (modalOptions.showLoadingIndicator) {
        Object.assign(swalOptions, {
            allowOutsideClick: false,
            allowEscapeKey: false,
            onBeforeOpen: () => {
                Swal.showLoading()
            },
        })
    }

    if (modalOptions.overrideSwalProps) {
        _merge(swalOptions, modalOptions.overrideSwalProps)
    }

    return Swal.fire(swalOptions)
}

/*export const showWarn = (message: string, title: string) => {
    const modalProps = {
        title: `Warning (${title})`,
        text: message,
        icon: 'warn',
        overrideSwalProps: {
            confirmButtonText: 'OK',
        },
    }

    showModal(modalProps)
}*/

export const showError = (message: string, title: string) => {
    const modalProps = {
        title: `Error (${title})`,
        text: message,
        icon: 'error',
        overrideSwalProps: {
            confirmButtonText: 'OK',
        },
    }

    return showModal(modalProps)
}

export const showSuccess = (message: string, title: string) => {
    const modalProps = {
        title,
        text: message,
        icon: 'success',
        overrideSwalProps: {
            confirmButtonText: 'OK',
        },
    }

    return showModal(modalProps)
}

export const showWarn = (message: string, title: string, swalProps: any = {}) => {
    const overrideSwalProps = { confirmButtonText: 'OK', ...swalProps }
    const modalProps = {
        title,
        text: message,
        icon: 'warning',
        overrideSwalProps
    }

    return showModal(modalProps)
}

export const showInfo = (message: string, title: string) => {
    const modalProps = {
        title,
        text: message,
        icon: 'info',
        overrideSwalProps: {
            confirmButtonText: 'OK',
        },
    }

    return showModal(modalProps)
}


export const showLoadingModal = (title: string, message: string) => {
    const modalProps = {
        title,
        text: message,
        showLoadingIndicator: true,
    }

    showModal(modalProps)
}

export const closeSweetAlert = () => {
    return Swal.close()
}
